import clsx from "clsx";
import { GripVerticalIcon } from "lucide-react";
import { bool } from "prop-types";
import { useContext } from "react";
import { GHOST_EL_ID } from "utils/createDraggingGhost";

import { TanStackRowProps } from "./constants";
import classes from "./DraggableButton.module.scss";
import ExcelTableContext from "./ExcelTableContext";
import { createTableRowGhost } from "./utils";

const stringify = (obj) => JSON.stringify(obj);

const DraggableButton = ({ isEditableCell, row }) => {
  const { isRowDragDisabled, setDraggedRow } = useContext(ExcelTableContext);
  const isDisabled = isRowDragDisabled(row);

  const onDragStart = (e) => {
    setDraggedRow(row);

    const ghost = createTableRowGhost(e);

    const { offsetX, offsetY } = e.nativeEvent;
    e.dataTransfer.setData("text/plain", stringify({ row }));
    e.dataTransfer.setDragImage(ghost, offsetX, offsetY);
  };

  const onDragEnd = (e) => {
    setDraggedRow(null);
    const rowEl = e.target.closest(".row");

    rowEl.classList.remove("dragged");
    const ghost = document.getElementById(GHOST_EL_ID);
    if (ghost) {
      document.body.removeChild(ghost);
    }
  };

  return (
    <div
      className={clsx(classes["draggable_cell"], {
        [classes["draggable_cell--editable-cell"]]: isEditableCell,
        [classes["draggable_cell--disabled"]]: isDisabled,
      })}
      draggable={!isDisabled}
      data-testid="draggable-button"
      data-show-on-row-hover
      onDragEnd={onDragEnd}
      onDragStart={onDragStart}
      title={
        isDisabled
          ? "You cannot drag Rows when multiple are already selected"
          : ""
      }
    >
      <GripVerticalIcon size={16} />
    </div>
  );
};

DraggableButton.propTypes = {
  isEditableCell: bool,
  row: TanStackRowProps,
};

export default DraggableButton;
